<template>
  <el-dialog
    :lock-scroll="false"
    :close-on-click-modal="false"
    title="车牌解绑"
    :visible="plate.dialogFormVisible"
    width="500px"
    @close="onCancleBtn"
  >
    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column show-overflow-tooltip label="车牌号" prop="plate">
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onConfirmBtn"> 确 定 </el-button>
      <el-button @click="onCancleBtn">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { fetchPlateList, reqUnbindPlate } from "@/api/url";
export default {
  props: {
    plate: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      tableData: [],
      multipleSelection: [],
    };
  },

  watch: {
    "plate.userId": {
      handler(val) {
        if (val) {
          this.getPLateList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    getPLateList() {
      this.$get(fetchPlateList(), { userId: this.plate.userId }).then((res) => {
        const { status, message, data } = res;
        if (status !== 200) {
          this.$message({
            type: "warning",
            message,
          });
          return;
        }
        this.tableData = data;
      });
    },
    handleSelectionChange(val) {
   
      this.multipleSelection = val;
    },
    onCancleBtn() {
      this.$emit("func");
    },
    onConfirmBtn() {
      const ids = this.multipleSelection.reduce((selectedIds, current) => {
        selectedIds.push(current.id);
        
        return selectedIds;
      }, []);
      this.$postRequest(reqUnbindPlate(), {
        ids,
        userId: this.plate.userId,
      }).then((res) => {
        const { status, message } = res;
        if (status !== 200) {
          this.$message({
            type: "warning",
            message,
          });
        } else {
          this.$message({
            type: "success",
            message,
          });
          this.$emit("func", "success");
        }
      });
    },
  },
};
</script>
<style scoped>
</style>